/** Definitions for create advanced script flow. At time of writing, these steps only represent the "with CCI" flow,
 *  but the intent is to add a definition that supports the legacy flow.
 */

import {
  onStep0Create,
  onStep1ReviewHarvestHistory,
  onStep2EnterPlantingPlan,
  onStep3ReviewScript,
  onStep4FinishFlow
} from './stepActions';

const stepActions = [
  onStep0Create,
  onStep1ReviewHarvestHistory,
  onStep2EnterPlantingPlan,
  onStep3ReviewScript,
  onStep4FinishFlow
];

export default {
  stepActions
};
